import React from 'react';
import PropTypes from 'prop-types';
import {CloseButton} from '@learningblocks/shared-components/lib/CloseButton';
import './style.scss';

/**
 * Header:
 *  - Header for LabelTestTube Component
 */
export function Header(props) {
  const renderCloseButton = () =>
    props.close && (
      <CloseButton
        className='component_header__close'
        close={props.close}
        size={props.size}
      />
    );
  return (
    <div className={`component_header ${props.className}`}>
      <h4 className='component_header__label'>{props.label}</h4>
      {renderCloseButton()}
    </div>
  );
}

Header.propTypes = {
  /**
   * className to set on wrapper component
   */
  className: PropTypes.string,
  /**
   * label of the componet
   */
  label: PropTypes.string,
  /**
   * Callback function to invoke when you wanna close the Questio Modal Window
   */
  close: PropTypes.func,
};

Header.defaultprops = {
  size: 'md',
  className: '',
};
